import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Palo Alto Innovate
            </h3>
            <p className="text-gray-300 mb-4 max-w-md">
              A Silicon Valley based venture capital firm investing in companies building revolutionary technologies and innovative solutions that shape the future.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors duration-200">
                  Palo Alto Innovate
                </a>
              </li>
              <li>
                <a href="/portfolio" className="text-gray-300 hover:text-white transition-colors duration-200">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="/aipai-index" className="text-gray-300 hover:text-white transition-colors duration-200">
                  AIPAI Index
                </a>
              </li>
              <li>
                <a href="/pai-capital" className="text-gray-300 hover:text-white transition-colors duration-200">
                  PAI Capital
                </a>
              </li>
              <li>
                <a href="/news" className="text-gray-300 hover:text-white transition-colors duration-200">
                  News
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Palo Alto, California</li>
              <li>Silicon Valley</li>
              <li>
                <a href="mailto:info@paloaltoinnovate.com" className="hover:text-white transition-colors duration-200">
                  info@paloaltoinnovate.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 sm:mb-0">
            Copyright © 2023-2025. All Rights Reserved. Palo Alto Innovate ® is a registered trademark of Palo Alto Innovate, LLC.
          </p>
          <div className="flex items-center space-x-4">
            <a href="/terms" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
              Terms of Use
            </a>
            <a href="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
              Website Builder
            </a>
          </div>
        </div>

        <div className="mt-4 text-xs text-gray-500">
          <p>Past performance is not indicative of future results. Investments may lose value. No offer to sell or solicitation of an offer to buy securities is made hereby.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
